import WithoutAnswerTag from './WithoutAnswerTag.component';

export default WithoutAnswerTag;
